let tmpl = require('./pic.ejs');
let style = require('./pic.css');

const formatPictures = (pics) => {
    let item;
    let url = '//d.ifengimg.com/';
    let rat;
    for (let i = 0, iLen = pics.length; i < iLen; i++) {
        item = pics[i];
        if (pics.length === 1) {
            rat = 'mw631/';
        } else if (pics.length === 2 || pics.length === 4) {
            if (item.h / 1 > item.w / 1) {
                rat = 'w309/';
            } else {
                rat = 'h309/';
            }
        } else {
            if (item.h / 1 > item.w / 1) {
                rat = 'w203/';
            } else {
                rat = 'h203/';
            }
        }
        item.url = item.url.replace(/^(?:https?:)?\/\//, '');
        item.purl = url + rat + item.url;
    }
    return pics;
};

module.exports = function(picturesData, mid) {
    let picData = formatPictures(picturesData);
    return tmpl({ picData, mid });
};



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.pic.mobile/app/modules/pic/index.js